"use client";

import React from "react";
import { Button, Flex, Text } from "@chakra-ui/react";

interface IconProps {
  isActive?: boolean;
}

interface SidebarItemProps {
  icon: React.ReactElement<IconProps>;
  label: string;
  isActive?: boolean;
  onClick?: () => void;
}

const SidebarItem: React.FC<SidebarItemProps> = ({
  icon,
  label,
  isActive = false,
  onClick,
}) => {
  // Clone the icon element and pass isActive prop to it
  const activeIcon = React.cloneElement(icon, { isActive });

  return (
    <Button
      variant="ghost"
      w="full"
      display="flex"
      justifyContent="flex-start"
      px={2}
      py={3}
      bg={isActive ? "gray.900" : "transparent"}
      _hover={{ bg: "gray.700" }}
      onClick={onClick}
    >
      <Flex gap={2} align="center">
        {activeIcon}
        <Text 
          color={isActive ? "blue.300" : "white"} 
          fontSize="base"
          fontWeight={isActive ? "bold" : "normal"}
        >
          {label}
        </Text>
      </Flex>
    </Button>
  );
};

export default SidebarItem;
